export const SECTION_ID = {
	MIGRATE_TO_CLOUD_SITE: 'migrate-to-cloud-site',
	PERFORMANCE_AND_SCALE: 'performance-and-scale',
} as const;
